/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiMasterTrainingAddPost } from '../fn/training/api-master-training-add-post';
import { ApiMasterTrainingAddPost$Params } from '../fn/training/api-master-training-add-post';
import { apiMasterTrainingDeleteGet } from '../fn/training/api-master-training-delete-get';
import { ApiMasterTrainingDeleteGet$Params } from '../fn/training/api-master-training-delete-get';
import { apiMasterTrainingEditPost } from '../fn/training/api-master-training-edit-post';
import { ApiMasterTrainingEditPost$Params } from '../fn/training/api-master-training-edit-post';
import { apiMasterTrainingGetActiveForApplicationGet } from '../fn/training/api-master-training-get-active-for-application-get';
import { ApiMasterTrainingGetActiveForApplicationGet$Params } from '../fn/training/api-master-training-get-active-for-application-get';
import { apiMasterTrainingGetActiveGet } from '../fn/training/api-master-training-get-active-get';
import { ApiMasterTrainingGetActiveGet$Params } from '../fn/training/api-master-training-get-active-get';
import { apiMasterTrainingGetActiveOptionsGet } from '../fn/training/api-master-training-get-active-options-get';
import { ApiMasterTrainingGetActiveOptionsGet$Params } from '../fn/training/api-master-training-get-active-options-get';
import { apiMasterTrainingGetAllGet } from '../fn/training/api-master-training-get-all-get';
import { ApiMasterTrainingGetAllGet$Params } from '../fn/training/api-master-training-get-all-get';
import { apiMasterTrainingGetByCriteriaPost } from '../fn/training/api-master-training-get-by-criteria-post';
import { ApiMasterTrainingGetByCriteriaPost$Params } from '../fn/training/api-master-training-get-by-criteria-post';
import { apiMasterTrainingGetTrainingCourseTypeMappingGet } from '../fn/training/api-master-training-get-training-course-type-mapping-get';
import { ApiMasterTrainingGetTrainingCourseTypeMappingGet$Params } from '../fn/training/api-master-training-get-training-course-type-mapping-get';
import { apiMasterTrainingInActiveGet } from '../fn/training/api-master-training-in-active-get';
import { ApiMasterTrainingInActiveGet$Params } from '../fn/training/api-master-training-in-active-get';
import { StringApiRespModel } from '../models/string-api-resp-model';
import { Training } from '../models/training';
import { TrainingApiRespModel } from '../models/training-api-resp-model';
import { TrainingCourseGroup } from '../models/training-course-group';
import { TrainingCourseTypeMapping } from '../models/training-course-type-mapping';
import { TrainingOption } from '../models/training-option';

@Injectable({ providedIn: 'root' })
export class TrainingService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiMasterTrainingAddPost()` */
  static readonly ApiMasterTrainingAddPostPath = '/api/Master/Training/Add';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterTrainingAddPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterTrainingAddPost$Response(params?: ApiMasterTrainingAddPost$Params, context?: HttpContext): Observable<StrictHttpResponse<TrainingApiRespModel>> {
    return apiMasterTrainingAddPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterTrainingAddPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterTrainingAddPost(params?: ApiMasterTrainingAddPost$Params, context?: HttpContext): Observable<TrainingApiRespModel> {
    return this.apiMasterTrainingAddPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<TrainingApiRespModel>): TrainingApiRespModel => r.body)
    );
  }

  /** Path part for operation `apiMasterTrainingEditPost()` */
  static readonly ApiMasterTrainingEditPostPath = '/api/Master/Training/Edit';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterTrainingEditPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterTrainingEditPost$Response(params?: ApiMasterTrainingEditPost$Params, context?: HttpContext): Observable<StrictHttpResponse<TrainingApiRespModel>> {
    return apiMasterTrainingEditPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterTrainingEditPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterTrainingEditPost(params?: ApiMasterTrainingEditPost$Params, context?: HttpContext): Observable<TrainingApiRespModel> {
    return this.apiMasterTrainingEditPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<TrainingApiRespModel>): TrainingApiRespModel => r.body)
    );
  }

  /** Path part for operation `apiMasterTrainingDeleteGet()` */
  static readonly ApiMasterTrainingDeleteGetPath = '/api/Master/Training/Delete';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterTrainingDeleteGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterTrainingDeleteGet$Response(params?: ApiMasterTrainingDeleteGet$Params, context?: HttpContext): Observable<StrictHttpResponse<StringApiRespModel>> {
    return apiMasterTrainingDeleteGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterTrainingDeleteGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterTrainingDeleteGet(params?: ApiMasterTrainingDeleteGet$Params, context?: HttpContext): Observable<StringApiRespModel> {
    return this.apiMasterTrainingDeleteGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringApiRespModel>): StringApiRespModel => r.body)
    );
  }

  /** Path part for operation `apiMasterTrainingInActiveGet()` */
  static readonly ApiMasterTrainingInActiveGetPath = '/api/Master/Training/InActive';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterTrainingInActiveGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterTrainingInActiveGet$Response(params?: ApiMasterTrainingInActiveGet$Params, context?: HttpContext): Observable<StrictHttpResponse<StringApiRespModel>> {
    return apiMasterTrainingInActiveGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterTrainingInActiveGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterTrainingInActiveGet(params?: ApiMasterTrainingInActiveGet$Params, context?: HttpContext): Observable<StringApiRespModel> {
    return this.apiMasterTrainingInActiveGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringApiRespModel>): StringApiRespModel => r.body)
    );
  }

  /** Path part for operation `apiMasterTrainingGetAllGet()` */
  static readonly ApiMasterTrainingGetAllGetPath = '/api/Master/Training/GetAll';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterTrainingGetAllGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterTrainingGetAllGet$Response(params?: ApiMasterTrainingGetAllGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Training>>> {
    return apiMasterTrainingGetAllGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterTrainingGetAllGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterTrainingGetAllGet(params?: ApiMasterTrainingGetAllGet$Params, context?: HttpContext): Observable<Array<Training>> {
    return this.apiMasterTrainingGetAllGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<Training>>): Array<Training> => r.body)
    );
  }

  /** Path part for operation `apiMasterTrainingGetActiveGet()` */
  static readonly ApiMasterTrainingGetActiveGetPath = '/api/Master/Training/GetActive';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterTrainingGetActiveGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterTrainingGetActiveGet$Response(params?: ApiMasterTrainingGetActiveGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Training>>> {
    return apiMasterTrainingGetActiveGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterTrainingGetActiveGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterTrainingGetActiveGet(params?: ApiMasterTrainingGetActiveGet$Params, context?: HttpContext): Observable<Array<Training>> {
    return this.apiMasterTrainingGetActiveGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<Training>>): Array<Training> => r.body)
    );
  }

  /** Path part for operation `apiMasterTrainingGetActiveOptionsGet()` */
  static readonly ApiMasterTrainingGetActiveOptionsGetPath = '/api/Master/Training/GetActiveOptions';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterTrainingGetActiveOptionsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterTrainingGetActiveOptionsGet$Response(params?: ApiMasterTrainingGetActiveOptionsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<TrainingOption>>> {
    return apiMasterTrainingGetActiveOptionsGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterTrainingGetActiveOptionsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterTrainingGetActiveOptionsGet(params?: ApiMasterTrainingGetActiveOptionsGet$Params, context?: HttpContext): Observable<Array<TrainingOption>> {
    return this.apiMasterTrainingGetActiveOptionsGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<TrainingOption>>): Array<TrainingOption> => r.body)
    );
  }

  /** Path part for operation `apiMasterTrainingGetTrainingCourseTypeMappingGet()` */
  static readonly ApiMasterTrainingGetTrainingCourseTypeMappingGetPath = '/api/Master/Training/GetTrainingCourseTypeMapping';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterTrainingGetTrainingCourseTypeMappingGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterTrainingGetTrainingCourseTypeMappingGet$Response(params?: ApiMasterTrainingGetTrainingCourseTypeMappingGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<TrainingCourseTypeMapping>>> {
    return apiMasterTrainingGetTrainingCourseTypeMappingGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterTrainingGetTrainingCourseTypeMappingGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterTrainingGetTrainingCourseTypeMappingGet(params?: ApiMasterTrainingGetTrainingCourseTypeMappingGet$Params, context?: HttpContext): Observable<Array<TrainingCourseTypeMapping>> {
    return this.apiMasterTrainingGetTrainingCourseTypeMappingGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<TrainingCourseTypeMapping>>): Array<TrainingCourseTypeMapping> => r.body)
    );
  }

  /** Path part for operation `apiMasterTrainingGetActiveForApplicationGet()` */
  static readonly ApiMasterTrainingGetActiveForApplicationGetPath = '/api/Master/Training/GetActiveForApplication';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterTrainingGetActiveForApplicationGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterTrainingGetActiveForApplicationGet$Response(params?: ApiMasterTrainingGetActiveForApplicationGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<TrainingCourseGroup>>> {
    return apiMasterTrainingGetActiveForApplicationGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterTrainingGetActiveForApplicationGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterTrainingGetActiveForApplicationGet(params?: ApiMasterTrainingGetActiveForApplicationGet$Params, context?: HttpContext): Observable<Array<TrainingCourseGroup>> {
    return this.apiMasterTrainingGetActiveForApplicationGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<TrainingCourseGroup>>): Array<TrainingCourseGroup> => r.body)
    );
  }

  /** Path part for operation `apiMasterTrainingGetByCriteriaPost()` */
  static readonly ApiMasterTrainingGetByCriteriaPostPath = '/api/Master/Training/GetByCriteria';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterTrainingGetByCriteriaPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterTrainingGetByCriteriaPost$Response(params?: ApiMasterTrainingGetByCriteriaPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Training>>> {
    return apiMasterTrainingGetByCriteriaPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterTrainingGetByCriteriaPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterTrainingGetByCriteriaPost(params?: ApiMasterTrainingGetByCriteriaPost$Params, context?: HttpContext): Observable<Array<Training>> {
    return this.apiMasterTrainingGetByCriteriaPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<Training>>): Array<Training> => r.body)
    );
  }

}
